import { _t } from "../../services/TranslationService.js";
import {APP_CONFIG} from "../constants/global-variables.js";

export async function cancelBet(bet_id) {
    const options = {
        method: "GET",
        credentials: "include",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
        },
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/cancelbet`;

    try {
        const res = await axios.post(
            url,
            {
                bet_id: bet_id,
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );
        console.log(res,'res');
        if(!res.data.success){
            $('body .cancelBtnMessageModal').children('p').text(_t(res.data.error));
            $('body .cancelBtnMessageModal').addClass('show');
            setTimeout(function(){
                $('body .cancelBtnMessageModal').removeClass('show');
            },3000);
        }

        if(res.data.success){
            $('body .singleBetTable').each(function(i,item){
               if($(item).children('.singleBetHeader').attr('bet-id') == bet_id){
                   $(item).remove();
               }
            });
        }
        return res.data;
    } catch (err) {
        alert(_t(err));
        console.log('Error getting documents', err);
    }
}